export const environment = {
  production: false,
  ENV_NAME: 'localhost',
  API_URL: '',
  JSREPORT_URL: 'https://reports.siteblindado.com',
  API_VERSION: '/v1',
};
